import {GetProvidersDentalGuideModel} from 'domain/usecases';
import {formatAddress} from 'presentation/utils';
import {DisabilityEnum} from 'presentation/constants';

import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';
import {FlowEnum} from '../../shared/constants/flowEnum';

export const parseOdontoSupportNetworkUnits = (
	units: GetProvidersDentalGuideModel,
): Units<FlowEnum.ODONTO>[] =>
	units?.prestadores?.map(unit => ({
		code: unit?.codigo?.toString(),
		name: unit?.nome,
		stateCode: unit?.uf,
		city: unit?.cidade,
		addressNumber: unit?.numero?.toString(),
		addressName: unit?.logradouro,
		addressComplement: unit?.complemento,
		district: unit?.bairro,
		cep: unit?.cep,
		referencePoint: unit?.pontoReferencia,
		disability: DisabilityEnum.ALL,
		latitude: unit?.latitude,
		longitude: unit?.longitude,
		distance: unit?.distancia,
		addressType: '',
		formattedAddress: formatAddress({
			type: '',
			state: unit?.uf,
			city: unit?.cidade,
			number: unit?.numero?.toString(),
			address: unit?.logradouro,
			complement: unit?.complemento,
			district: unit?.bairro,
			zipCode: unit?.cep,
			reference: unit?.pontoReferencia,
		}),
		phoneNumbers: unit?.contatos,
	}));
